module.exports = __webpack_public_path__ + "a02774bdf569ea52672aaf87a9394cc7.svg";